import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDataFetch } from "../../hooks/useDataFetch";
import { useEffect } from "react";

const validationSchema = Yup.object().shape({
  cost_monthly_late_value: Yup.number().required(
    "El porcentaje de mora de la mensualidad es requerido"
  ),
  cost_annual_late_value: Yup.number().required(
    "El porcentaje de mora de la matrícula es requerido"
  ),
});

const Configuration = ({ refetchStudent }) => {
  const { patchData, getData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { data: config, refetch } = getData(
    ["getconfiguration"],
    "/configuration",
    { enabled: true }
  );

  const { mutate: updateConfig, isLoading: isPostLoading } = patchData(
    "/configuration",
    {},
    {
      onSuccess: (data) => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  useEffect(()=> {
    if(config){
        setValue("cost_annual_late_value", config.data.find( e=> e.id == 2).value);
        setValue("cost_monthly_late_value", config.data.find( e=> e.id == 1).value);
    }
  }, [config]);

  const onSubmit = (data) => {
    updateConfig({
      id: 1,
      value: data?.cost_monthly_late_value,
      name: "Tasa Mora Mensualidad",
    });
    updateConfig({
      id: 2,
      value: data?.cost_annual_late_value,
      name: "Tasa Mora Matrícula",
    });
  };

  return (
    <div className="card">
      <div className="card-body">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div
              className={`col-md-6 mb-3 ${
                errors.cost_monthly_late_value?.message
                  ? "is-invalid"
                  : "is-valid"
              }`}
            >
              <label htmlFor="firstName">% de mora de la mensualidad</label>
              <input
                type="number"
                className="form-control"
                {...register("cost_monthly_late_value")}
              />

              {errors.cost_monthly_late_value?.message ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.cost_monthly_late_value?.message}
                </div>
              ) : null}
            </div>
            <div
              className={`col-md-6 mb-3 ${
                errors.cost_annual_late_value?.message
                  ? "is-invalid"
                  : "is-valid"
              }`}
            >
              <label htmlFor="firstName">% de mora de la matrícula</label>
              <input
                type="number"
                className="form-control"
                {...register("cost_annual_late_value")}
              />

              {errors.cost_annual_late_value?.message ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {errors.cost_annual_late_value?.message}
                </div>
              ) : null}
            </div>
          </div>

          <hr className="mb-4" />
          <button
            className="btn btn-primary btn-lg btn-block"
            type="submit"
            disabled={isPostLoading}
          >
            Guardar
          </button>
        </form>
      </div>
    </div>
  );
};

export default Configuration;
